module.exports = __webpack_public_path__ + "static/media/toolbox.61cd0818.png";